/**
 * cellList 를 받아
 * is_coming_soon 필드를 y 값으로 추가하고 반환
 * @param cellList
 * @returns {(*&{is_coming_soon: string})[]|*[]}
 */
export const comingSoonCell = (cellList = []) => {
  if (cellList?.length < 1) {
    return []
  }

  return cellList.map((cell) => {
    return {
      ...cell,
      is_coming_soon: 'y',
    }
  })
}
